export const CandidatePortalDashboardViewsDataTestIds = {
  VIEW_STATE_NO_PENDING_MATCHES: 'candidate-dashboard-view-state-no-pending-matches',
  VIEW_STATE_NO_ARCHIVED_MATCHES: 'candidate-dashboard-view-state-no-archived-matches',
  VIEW_STATE_END_OF_MATCHES: 'candidate-dashboard-view-state-end-of-matches',
  VIEW_STATE_NOT_OPEN_TO_MATCHES: 'candidate-dashboard-view-state-not-open-to-matches',
  VIEW_STATE_BUTTON: 'candidate-dashboard-view-state-button',
  VIEW_STATE_HEADER_TEXT: 'candidate-dashboard-view-state-header-text',
  VIEW_STATE_BODY_TEXT: 'candidate-dashboard-view-state-body-text',
  VIEW_STATE_ICON: 'candidate-dashboard-view-state-icon',
};

export enum ConnectCandidateMatchDashboardDataTestIds {
  ACCEPT_MATCH_MODAL = 'connect-candidate-match-dashboard-accept-match-modal',
  ALREADY_CONNECTED_MODAL = 'connect-candidate-match-dashboard-already-connected-modal',
  BODY_CONTAINER = 'connect-candidate-match-dashboard-body-container',
  DASHBOARD_CONTAINER = 'connect-candidate-match-dashboard-container',
  PAGINATION_HEADER_CONTAINER = 'connect-candidate-match-dashboard-pagination-header-container',
  REJECT_MATCH_MODAL = 'connect-candidate-match-dashboard-reject-match-modal',
}

export enum ConnectCandidateMatchCardDataTestIds {
  BODY_CONTAINER = 'connect-candidate-match-dashboard-match-card-body-container',
  BUTTON_GROUP_CONTAINER = 'connect-candidate-match-dashboard-match-card-button-group-container',
  CARD_TITLE_CONTAINER = 'connect-candidate-match-dashboard-match-card-title-container',
  CARD_TITLE_TEXT = 'connect-candidate-match-dashboard-match-card-title-text',
  DIVIDER = 'connect-candidate-match-dashboard-match-card-divider',
  HEADER_CONTAINER = 'connect-candidate-match-dashboard-match-card-header-container',
  MATCH_CARD_CONTAINER = 'connect-candidate-match-dashboard-match-card-container',
  PREFERENCE_MATCHES_CONTAINER = 'connect-candidate-match-dashboard-match-card-preference-matches-container',
  PREFERENCE_MATCH_CHIP = 'connect-candidate-match-dashboard-match-card-preference-match-chip',
  MATCH_CARD = 'connect-candidate-match-dashboard-match-card',
}

export enum ConnectCandidateMatchArchiveCardDataTestIds {
  MATCH_CARD = 'connect-candidate-match-archive-card',
  TITLE_CONTAINER = 'connect-candidate-match-archive-card-title-container',
  TITLE_TEXT = 'connect-candidate-match-archive-card-title-text',
  TITLE_ICON = 'connect-candidate-match-archive-card-title-icon',
  ACTION_DATE_TEXT = 'connect-candidate-match-archive-card-action-date-text',
  HEADER_CONTAINER = 'connect-candidate-match-archive-card-header-container',
  SCHOOL_NAME_TEXT = 'connect-candidate-match-archive-card-school-name-text',
  PRINCIPAL_SECTION = 'connect-candidate-match-archive-card-principal-section',
  VIEW_SCHOOL_DETAILS_BUTTON = 'connect-candidate-match-archive-card-view-school-details-button',
  DIVIDER = 'connect-candidate-match-archive-card-divider',
}

export enum ConnectCandidateMatchArchiveDashboardDataTestIds {
  FILTER_BUTTON_GROUP = 'connect-candidate-match-archive-card-filter-button-group',
  FILTER_ALL_BUTTON = 'connect-candidate-match-archive-card-filter-all-button',
  FILTER_INTERESTED_BUTTON = 'connect-candidate-match-archive-card-filter-interested-button',
  FILTER_NO_THANKS_BUTTON = 'connect-candidate-match-archive-card-filter-no-thanks-button',
  DASHBOARD_CONTAINER = 'connect-candidate-match-archive-dashboard-container',
  DASHBOARD_BODY = 'connect-candidate-match-archive-dashboard-body',
  DASHBOARD_HEADER = 'connect-candidate-match-archive-dashboard-header',
  MOBILE_BUTTON_GROUP_CONTAINER = 'connect-candidate-match-archive-dashboard-mobile-button-group-container',
}

export enum ConnectCandidateMatchCardSchoolSectionDataTestIds {
  SCHOOL_HEADER_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-header-container',
  SCHOOL_NAME_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-name-container',
  SCHOOL_NAME_TEXT = 'connect-candidate-match-dashboard-match-card-school-name-text',
  DISTRICT_NAME_TEXT = 'connect-candidate-match-dashboard-match-card-district-name-text',
  SCHOOL_INFO_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-info-container',
  SCHOOL_ROLES_LIST_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-roles-list-container',
  SCHOOL_SECTION_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-section-container',
  SAVE_SCHOOL_BUTTON = 'connect-candidate-match-dashboard-match-card-save-school-button',
  SAVE_SCHOOL_BUTTON_CONTAINER = 'connect-candidate-match-dashboard-match-card-save-school-button-container',
  SCHOOL_PRINCIPAL_NAME_TEXT = 'connect-candidate-match-dashboard-match-card-school-principal-name-text',
  SCHOOL_AND_DISTRICT_NAME_CONTAINER = 'connect-candidate-match-dashboard-match-card-school-and-district-name-container',
}

export enum ConnectCandidateMatchCardButtonGroupDataTestIds {
  ACCEPT_MATCH_BUTTON = 'connect-candidate-match-dashboard-match-card-button-group-accept-match-button',
  ALREADY_CONNECTED_BUTTON = 'connect-candidate-match-dashboard-match-card-button-group-already-connected-button',
  REJECT_MATCH_BUTTON = 'connect-candidate-match-dashboard-match-card-button-group-reject-match-button',
}

export enum ConnectCandidateMatchDashboardPaginationHeaderDataTestIds {
  HEADER_CONTAINER = 'connect-candidate-match-dashboard-pagination-header',
  MATCH_TITLE = 'connect-candidate-match-dashboard-pagination-header-match-title',
  PAGINATION_BUTTON_GROUP = 'connect-candidate-match-dashboard-pagination-header-button-group',
  PREV_BUTTON = 'connect-candidate-match-dashboard-pagination-header-button-group-prev-button',
  NEXT_BUTTON = 'connect-candidate-match-dashboard-pagination-header-button-group-next-button',
  PAGE_LOCATION_TEXT = 'connect-candidate-match-dashboard-pagination-header-button-group-location-text',
  PAGE_NUMBER = 'connect-candidate-match-dashboard-pagination-header-button-group-page-number',
  TOTAL_MATCHES_NUMBER = 'connect-candidate-match-dashboard-pagination-header-button-group-total-pages-number',
}

export enum ConnectCandidateMatchDashboardAcceptMatchModalDataTestIds {
  ACCEPT_MATCH_BUTTON_GROUP = 'connect-candidate-match-dashboard-accept-match-modal-button-group',
  ACCEPT_MATCH_OPTION_GROUP = 'connect-candidate-match-dashboard-accept-match-modal-option-group',
  CANCEL_BUTTON = 'connect-candidate-match-dashboard-accept-match-modal-cancel-button',
  ACCEPT_MATCH_BUTTON = 'connect-candidate-match-dashboard-accept-match-modal-accept-match-button',
  HEADER_TEXT = 'connect-candidate-match-dashboard-accept-match-modal-header-text',
  SCHEDULE_INTERVIEW_OPTION = 'connect-candidate-match-dashboard-accept-match-modal-option-group-schedule-interview-option',
  SCHEDULE_INTERVIEW_OPTION_LABEL = 'connect-candidate-match-dashboard-accept-match-modal-option-group-schedule-interview-option-label',
  SCHEDULE_INTERVIEW_OPTION_CHECKED_ICON = 'connect-candidate-match-dashboard-accept-match-modal-option-group-schedule-interview-option-checked-icon',
  SCHEDULE_INTERVIEW_OPTION_UNCHECKED_ICON = 'connect-candidate-match-dashboard-accept-match-modal-option-group-schedule-interview-option-unchecked-icon',
  EMAIL_OPTION = 'connect-candidate-match-dashboard-accept-match-modal-option-group-email-option',
  EMAIL_OPTION_LABEL = 'connect-candidate-match-dashboard-accept-match-modal-option-group-email-option-label',
  EMAIL_OPTION_CHECKED_ICON = 'connect-candidate-match-dashboard-accept-match-modal-option-group-email-option-checked-icon',
  EMAIL_OPTION_UNCHECKED_ICON = 'connect-candidate-match-dashboard-accept-match-modal-option-group-email-option-unchecked-icon',
}

export enum ConnectCandidateMatchDashboardAlreadyConnectedModalDataTestIds {
  HEADER_TEXT = 'connect-candidate-match-dashboard-already-connected-modal-header-text',
  CANCEL_BUTTON = 'connect-candidate-match-dashboard-already-connected-modal-cancel-button',
  SUBMIT_BUTTON = 'connect-candidate-match-dashboard-already-connected-modal-submit-button',
  OPTION_GROUP = 'connect-candidate-match-dashboard-already-connected-modal-option-group',
  EMAIL_OPTION_LABEL = 'connect-candidate-match-dashboard-already-connected-modal-option-group-email-option-label',
  EMAIL_OPTION_CHECKBOX = 'connect-candidate-match-dashboard-already-connected-modal-option-group-email-option-checkbox',
  TEXT_OPTION_LABEL = 'connect-candidate-match-dashboard-already-connected-modal-option-group-text-option-label',
  TEXT_OPTION_CHECKBOX = 'connect-candidate-match-dashboard-already-connected-modal-option-group-text-option-checkbox',
  PHONE_CALL_OPTION_LABEL = 'connect-candidate-match-dashboard-already-connected-modal-option-group-phone-option-label',
  PHONE_CALL_OPTION_CHECKBOX = 'connect-candidate-match-dashboard-already-connected-modal-option-group-phone-option-checkbox',
  ON_SITE_INTERVIEW_OPTION_LABEL = 'connect-candidate-match-dashboard-already-connected-modal-option-group-on-site-interview-option-label',
  ON_SITE_INTERVIEW_OPTION_CHECKBOX = 'connect-candidate-match-dashboard-already-connected-modal-option-group-on-site-interview-option-checkbox',
  VIRTUAL_MEETING_OPTION_LABEL = 'connect-candidate-match-dashboard-already-connected-modal-option-group-virtual-meeting-option-label',
  VIRTUAL_MEETING_OPTION_CHECKBOX = 'connect-candidate-match-dashboard-already-connected-modal-option-group-virtual-meeting-option-checkbox',
}

export enum ConnectCandidateMatchDashboardInAppMatchMessagingModalDataTestIds {
  MODAL = 'connect-candidate-match-dashboard-in-app-match-messaging-modal',
  HEADER_TEXT = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-header-text',
  MESSAGE_INPUT = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-message-input',
  SEND_BUTTON = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-send-button',
  CANCEL_BUTTON = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-cancel-button',
  ALERT_MESSAGE = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-alert-message',
  PRINCIPAL_MESSAGE_SECTION = 'connect-candidate-match-dashboard-in-app-match-messaging-modal-principal-message-section',
}

export enum ConnectCandidateMatchDashboardRejectMatchModalDataTestIds {
  REJECT_MATCH_BUTTON_GROUP = 'connect-candidate-match-dashboard-reject-match-modal-button-group',
  CANCEL_BUTTON = 'connect-candidate-match-dashboard-reject-match-modal-cancel-button',
  REJECT_MATCH_BUTTON = 'connect-candidate-match-dashboard-reject-match-modal-reject-match-button',
  HEADER_TEXT = 'connect-candidate-match-dashboard-reject-match-modal-header-text',
  REJECT_MATCH_OPTION_GROUP = 'connect-candidate-match-dashboard-reject-match-modal-option-group',
  NO_LONGER_LOOKING_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-no-longer-looking-option-label',
  NO_LONGER_LOOKING_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-no-longer-looking-option-checkbox',
  SCHOOL_TOO_FAR_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-school-too-far-option-label',
  SCHOOL_TOO_FAR_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-school-too-far-option-checkbox',
  NO_MATCHING_OPENING_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-no-matching-opening-option-label',
  NO_MATCHING_OPENING_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-no-matching-opening-option-checkbox',
  COMPENSATION_BENEFITS_UNMET_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-compensation-benefits-unmet-option-label',
  COMPENSATION_BENEFITS_UNMET_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-compensation-benefits-unmet-option-checkbox',
  WRONG_ENVIRONMENT_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-wrong-environment-option-label',
  WRONG_ENVIRONMENT_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-wrong-environment-option-checkbox',
  OTHER_REJECT_REASON_LABEL = 'connect-candidate-match-dashboard-reject-match-modal-option-group-other-option-label',
  OTHER_REJECT_REASON_CHECKBOX = 'connect-candidate-match-dashboard-reject-match-modal-option-group-other-option-checkbox',
}

export enum CandidatePortalDataTestIds {
  CANDIDATE_PORTAL_CONTAINER = 'candidate-portal-container',
  NAVIGATION_TAB_MENU = 'candidate-portal-navigation-tab-menu',
}

export enum ConnectCandidatePrincipalDataTestIds {
  PRINCIPAL_COMPONENT = 'connect-candidate-principal-component',
  PRINCIPAL_NAME_TEXT = 'connect-candidate-principal-name-text',
  PRINCIPAL_MESSAGE_NAME_TEXT = 'connect-candidate-principal-message-name-text',
  PRINCIPAL_AVATAR = 'connect-candidate-principal-avatar',
  PRINCIPAL_ICON = 'connect-candidate-principal-icon',
  PRINCIPAL_MATCH_ARCHIVE_NAME_TEXT = 'connect-candidate-principal-match-archive-name-text',
  PRINCIPAL_MESSAGE_CONTAINER = 'connect-candidate-principal-message-container',
  PRINCIPAL_MESSAGE_HEADER_TEXT = 'connect-candidate-principal-message-header-text',
  PRINCIPAL_MESSAGE_TEXT = 'connect-candidate-principal-message-text',
}
